import {makeStyles} from "@material-ui/styles";

const drawerWidth = 320;

export default makeStyles(theme => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  topMenu: {
    overflow: 'auto',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    wordBreak: "break-all",
    "& $searchlist": {
      display: "flex",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    wordBreak: "normal",
    overflowX: "hidden",
    width: theme.spacing(7) + 40,
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth,
    },
    "& $searchlist": {
      display: "none",
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  content: {
    padding: theme.spacing(3),
  },

  /* sidebarList: {
    marginTop: theme.spacing(6),
  }, */
  searchlist: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    transition: theme.transitions.create("visibility", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
      delay: theme.transitions.duration.enteringScreen,
    }),
  },
  mobileBackButton: {
    marginTop: theme.spacing(0.5),
    marginLeft: 18,
    [theme.breakpoints.only("sm")]: {
      marginTop: theme.spacing(0.625),
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  sideBarItem: {
    alignItems: "flex-start"
  },
}));
